import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css';
import { MdOutlineStorefront } from "react-icons/md";
import Shoplogo from '../icons/Shop4u.png';
import { FaRegUser } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa6";
const Navbar = () => {
  const [userName, setUserName] = useState('');
  const [location, setLocation] = useState('');
  const [pincode, setPincode] = useState('');
  const [showModal, setShowModal] = useState(false);

  const API_KEY = 'AIzaSyCGhSnndOY38FfCgNfSldjpZQX6cT_KpC8';

  useEffect(() => {
    fetchStoredLocation();
    fetchUserName();
  }, []);

  const fetchStoredLocation = () => {
    const stored = localStorage.getItem('location');
    if (stored) {
      const parsed = JSON.parse(stored);
      setLocation(`${parsed.city} ${parsed.pincode}`);
    } else {
      fetchCurrentLocation();
    }
  };

  const fetchCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${API_KEY}`
          );
          const data = await res.json();

          if (data.status === 'OK' && data.results.length > 0) {
            const components = data.results[0].address_components;
            let city = '';
            let pin = '';

            components.forEach((comp) => {
              if (comp.types.includes('administrative_area_level_2')) {
                city = comp.long_name;
              }
              if (comp.types.includes('postal_code')) {
                pin = comp.long_name;
              }
            });

            if (city && pin) {
              setLocation(`${city} ${pin}`);
              localStorage.setItem('location', JSON.stringify({ city, pincode: pin }));
            } else {
              setLocation('Location not found');
            }
          }
        } catch (error) {
          console.error('Geolocation error:', error);
          setLocation('Error retrieving location');
        }
      });
    } else {
      setLocation('Geolocation not supported');
    }
  };

  const fetchUserName = async () => {
    try {
      const userId = localStorage.getItem('userId');
      const vendorId = localStorage.getItem('vendorId');
      if (!userId && !vendorId) return;

      const response = await fetch(`${process.env.REACT_APP_API_URL}/getName`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, vendorId }),
      });

      const result = await response.json();
      if (result.status === 'ok' && result.data?.fname) {
        setUserName(result.data.fname);
      }
    } catch (error) {
      console.error('Error fetching name:', error);
    }
  };

  const handleSaveLocation = async () => {
    if (!pincode.trim()) return alert('Please enter a valid pincode');

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${API_KEY}`
      );
      const data = await res.json();

      if (data.status === 'OK' && data.results.length > 0) {
        const components = data.results[0].address_components;
       let city = '';

components.forEach((comp) => {
  if (comp.types.includes('administrative_area_level_2')) {
    city = comp.long_name;
  } else if (!city && comp.types.includes('locality')) {
    city = comp.long_name;
  } else if (!city && comp.types.includes('sublocality_level_1')) {
    city = comp.long_name;
  } else if (!city && comp.types.includes('administrative_area_level_1')) {
    city = comp.long_name;
  }
});

if (!city) city = 'Your Area';


        setLocation(`${city} ${pincode}`);
        localStorage.setItem('location', JSON.stringify({ city, pincode }));
        setShowModal(false);
      } else {
        alert('Invalid Pincode');
      }
    } catch (err) {
      console.error('Error fetching city from pincode:', err);
      alert('Could not fetch location for this pincode');
    }
  };

  return (
    <>
    <nav className="custom-navbar shadow-sm">
  <div className="container-fluid d-flex align-items-center justify-content-between px-4 py-2">
    
    {/* Logo */}
    <div className="d-flex align-items-center">
      <Link to="/">
        <img src={Shoplogo} alt="logo" style={{ height: '40px' }} />
      </Link>
    </div>

            {/* 📍 Location Display */}
            <div >
              <div style={{ cursor: 'pointer' }} onClick={() => setShowModal(true)}>
                <i className="fas fa-map-marker-alt me-1"></i>
                {location || 'Choose your location'}
              </div>
            </div>
    {/* Search Bar with Dropdown */}
    <div className="search-bar d-flex align-items-center">
      <select className="search-dropdown">
        <option>Products</option>
        <option>Services</option>
      </select>
      <input type="text" className="search-input" placeholder="I'm looking for..." />
      <button className="search-button">Search</button>
    </div>

    {/* Right Side Icons */}
    <div className="d-flex align-items-center gap-3">
      <Link to="/vendor/signup" className="icon-link"><MdOutlineStorefront /> Become a Seller</Link>
     <div className='heart-items'>
    <FaRegHeart /></div>
      {userName ? (
        <Link to="/Vendor/UserProfile" className="profile-circle"> {userName.charAt(0).toUpperCase()} </Link>
      ) : (
        <Link to="/Vendor/Signup" className="profile-circle"><FaRegUser /></Link>
      )}
    </div>
  </div>
</nav>

   
      {/* 📍 Modal for Manual Pincode Selection */}
      {showModal && (
        <div className="pincodemodel-container modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="pincodemodel modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content text-center p-3">
              <button
                type="button"
                className="btn-close ms-auto"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              ></button>

              <h5 className="text-success fw-bold mb-2">CHOOSE YOUR PINCODE</h5>
              <p className="text-muted mb-3">
                This helps us find the best products and stores available in your area.
              </p>

              <div className="input-group mb-3">
                <span className="input-group-text">
                  <i className="fas fa-map-pin"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  placeholder="Enter Pincode"
                />
              </div>

              <button className="btn btn-danger w-100" onClick={handleSaveLocation}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
